import React from 'react'
import NavBar from './NavBar'
import './Header.css';
function Header() {
  return (
    <div div className='header fixed-top'>
      <div className='container'>
        <div className='row'>
            <div className='col-md-3'>
            <img src="./logo.jpeg" alt="Logo"  height={100}/>
            </div>
            <div className='col-md-9 d-flex align-items-center justify-content-end'>
                <NavBar/>
            </div>
        </div>
      </div>
    </div>
  )
}

export default Header
